var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.model),function(el,i){return _c('div',{key:i},[(el.type)?_c('a-input-' + el.type,{tag:"component",attrs:{"model":el,"values":_vm.data,"value":_vm.data[el.name],"config":_vm.config,"readonly":""}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }